module.exports = __webpack_public_path__ + "img/bgtop.10cd4169.jpg";